module.exports = __webpack_public_path__ + "img/jacket_2.50db4a57.png";